import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TrackingService {
  private scriptsPerPage: { [key: string]: (() => void)[] } = {
    '/xavi-pay/login': [this.includeMetaPixel],
    '/xavi-pay/home': [this.includeMetaPixel],
    '/xavi-pay/register/pf/success': [
      this.includeMetaPixel,
      this.includeGoogleTag,
      this.includeConversionEvent,
    ],
    '/xavi-pay/register/pj/success': [
      this.includeMetaPixel,
      this.includeGoogleTag,
      this.includeConversionEvent,
    ],
  };

  constructor(private router: Router) {
    if (!this.isProductionDomain()) return;

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.includeScripts();
      }
    });
  }

  private isProductionDomain(): boolean {
    return window.location.hostname === 'homebroker.ozcambio.com.br';
  }

  private includeScripts() {
    if (!this.isProductionDomain()) return;

    const actualUrl = this.router.url.split('?')[0];
    const scriptsToRun = this.scriptsPerPage[actualUrl];

    if (scriptsToRun) {
      scriptsToRun.forEach((scriptFn) => scriptFn.call(this));
    }
  }

  private includeMetaPixel() {
    if (!this.isProductionDomain()) return;
    if (document.getElementById('fb-pixel')) return;

    const script = document.createElement('script');
    script.id = 'fb-pixel';
    script.innerHTML = `
      !function(f,b,e,v,n,t,s) {
        if(f.fbq) return; n=f.fbq=function() {
          n.callMethod ? n.callMethod.apply(n,arguments) : n.queue.push(arguments)
        };
        if(!f._fbq) f._fbq=n; n.push=n; n.loaded=!0; n.version='2.0';
        n.queue=[]; t=b.createElement(e); t.async=!0;
        t.src=v; s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)
      }(window, document,'script', 'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '720768009703188');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);

    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=720768009703188&ev=PageView&noscript=1" />`;
    document.body.appendChild(noscript);
  }

  private includeGoogleTag() {
    if (!this.isProductionDomain()) return;
    if (document.getElementById('gtag-script')) return;

    const script = document.createElement('script');
    script.id = 'gtag-script';
    script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-11077376261';
    script.async = true;
    document.head.appendChild(script);

    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-11077376261');
    `;
    document.head.appendChild(inlineScript);
  }

  private includeConversionEvent() {
    if (!this.isProductionDomain()) return;
    if (document.getElementById('conversion-event')) return;

    const script = document.createElement('script');
    script.id = 'conversion-event';
    script.innerHTML = `gtag('event', 'conversion', {'send_to': 'AW-11077376261/baoXCMvlsfkYEIWyjaIp'});`;
    document.head.appendChild(script);
  }
}
